<div class="calendar-refineby-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'"
    (contextmenu)="onContextMenu($event)" (touchstart)="touchstart()" (touchend)="touchend($event)">
    <refineby [config]="refinebyConfig"></refineby>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>
</div>